export const easeInQuad = (x, t, b, c, d) => c * (t /= d) * t + b
export const easeOutQuad = (x, t, b, c, d) => -c * (t /= d) * (t - 2) + b
export const easeInOutQuad = (x, t, b, c, d) => {
  if ((t /= d / 2) < 1) return (c / 2) * t * t + b
  return (-c / 2) * (--t * (t - 2) - 1) + b
}

export const easeInCubic = (x, t, b, c, d) => c * (t /= d) * t * t + b
export const easeOutCubic = (x, t, b, c, d) => c * ((t = t / d - 1) * t * t + 1) + b
export const easeInOutCubic = (x, t, b, c, d) => {
  if ((t /= d / 2) < 1) return (c / 2) * t * t * t + b
  return (c / 2) * ((t -= 2) * t * t + 2) + b
}

export const easeInQuart = (x, t, b, c, d) => c * (t /= d) * t * t * t + b
export const easeOutQuart = (x, t, b, c, d) => -c * ((t = t / d - 1) * t * t * t - 1) + b
export const easeInOutQuart = (x, t, b, c, d) => {
  if ((t /= d / 2) < 1) return (c / 2) * t * t * t * t + b
  return (-c / 2) * ((t -= 2) * t * t * t - 2) + b
}

export const easeInQuint = (x, t, b, c, d) => c * (t /= d) * t * t * t * t + b
export const easeOutQuint = (x, t, b, c, d) => c * ((t = t / d - 1) * t * t * t * t + 1) + b
export const easeInOutQuint = (x, t, b, c, d) => {
  if ((t /= d / 2) < 1) return (c / 2) * t * t * t * t * t + b
  return (c / 2) * ((t -= 2) * t * t * t * t + 2) + b
}

export const easeInSine = (x, t, b, c, d) => -c * Math.cos((t / d) * (Math.PI / 2)) + c + b
export const easeOutSine = (x, t, b, c, d) => c * Math.sin((t / d) * (Math.PI / 2)) + b
export const easeInOutSine = (x, t, b, c, d) => (-c / 2) * (Math.cos((Math.PI * t) / d) - 1) + b

export const easeInExpo = (x, t, b, c, d) => (t == 0 ? b : c * Math.pow(2, 10 * (t / d - 1)) + b)
export const easeOutExpo = (x, t, b, c, d) => (t == d ? b + c : c * (-Math.pow(2, (-10 * t) / d) + 1) + b)
export const easeInOutExpo = (x, t, b, c, d) => {
  if (t == 0) return b
  if (t == d) return b + c
  if ((t /= d / 2) < 1) return (c / 2) * Math.pow(2, 10 * (t - 1)) + b
  return (c / 2) * (-Math.pow(2, -10 * --t) + 2) + b
}

export const easeInCirc = (x, t, b, c, d) => -c * (Math.sqrt(1 - (t /= d) * t) - 1) + b
export const easeOutCirc = (x, t, b, c, d) => c * Math.sqrt(1 - (t = t / d - 1) * t) + b
export const easeInOutCirc = (x, t, b, c, d) => {
  if ((t /= d / 2) < 1) return (-c / 2) * (Math.sqrt(1 - t * t) - 1) + b
  return (c / 2) * (Math.sqrt(1 - (t -= 2) * t) + 1) + b
}
